<template>
  <v-navigation-drawer app :color="colors.NEUTRAL">
    <v-list>
      <v-list-item>
        <v-btn block :color="colors.PRIMARY" @click="$router.push({ name: 'addClient' })">
          Add Client
        </v-btn>
      </v-list-item>
      
      <v-list-item>
        <ClientsMenu 
          :clients="clientMenuItems"
          :filtered-clients="filteredClients"
          :menu="menu"
          :search-query="searchQuery"
          @update:menu="menu = $event"
          @update:search-query="searchQuery = $event"
          @select-client="selectClient"
        />
      </v-list-item>

      <v-list-item class="activity-history-button">
        <v-btn 
          block 
          :color="colors.PRIMARY" 
          @click="$router.push({ name: 'activityHistory' })"
        >
          Activity History
        </v-btn>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { ref, defineProps } from 'vue';
import { useRouter } from 'vue-router';
import type Client from '@/models/client';
import ClientsMenu from '@/components/layout/ClientsMenu.vue';

const router = useRouter();
const menu = ref(false);
const searchQuery = ref('');

const colors = {
  PRIMARY: '#714FE3',
  ACCENT: '#F29B00',
  NEUTRAL: '#FFFFFF'
};

const props = defineProps<{
  clientMenuItems: Client[];
  filteredClients: Client[];
}>();

const selectClient = (client: Client) => {
  menu.value = false;
  router.push(`/client/${client.id}`);

  setTimeout(() => {
    searchQuery.value = '';
  }, 300);
};
</script> 